import EXIF from "exif-js";
export const resizeImage = ({ file, sizes }) => {
    // console.log('before xxx got hereeeee')
    const resize = (image, maxSize) => {
      let width = image.width;
      let height = image.height;
      if (width > height) {
        if (width > maxSize) {
          height *= maxSize / width;
          width = maxSize;
        }
      } else {
        if (height > maxSize) {
          width *= maxSize / height;
          height = maxSize;
        }
      }
      return { width, height };
    };
  
    const dataURItoBlob = dataURI => {
      const bytes =
        dataURI.split(",")[0].indexOf("base64") >= 0
          ? atob(dataURI.split(",")[1])
          : unescape(dataURI.split(",")[1]);
      const mime = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];
      const max = bytes.length;
      const ia = new Uint8Array(max);
      for (let i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
      return new Blob([ia], { type: mime });
    };
  
    return new Promise((ok, no) => {
      // console.log('hhvvbefore hhh got hereeeee')
      if (!file.type.match(/image.*/)) {
        no(new Error("Not an image"));
        return;
      }
  
      const url = URL.createObjectURL(file);
      const image = new Image();
  
      image.onload = () => {
        // console.log('before got hereeeee')
        EXIF.getData(image, async () => {
          //const orientation = EXIF.getTag(image, "Orientation");
          const imageRatio = image.width / image.height;
          // console.log('ceheck2 got hereeeee')
          try {
            const blobs = await Promise.all(sizes.map(maxSize => {
              // console.log('ceheck1 got hereeeee')
              return new Promise(resolve => {
                const { width, height } = resize(image, maxSize)
                // console.log('browser info===>>>', Bowser.parse(window.navigator.userAgent));
                //const browserInfo = Bowser.parse(window.navigator.userAgent);
                /*if (browserInfo.browser && bimagerowserInfo.browser.name !== 'Safari') {
                  console.log('fddfceheck3 got hereeeee==>>>', orientation)
                  // console.log('ceheck iffff true new orientation got hereeeee', orientation)
                  const canvas = loadImage.scale(, {
                    orientation: orientation || 0,
                    maxWidth: width,
                    // maxHeight: height
                  });
                  canvas.toBlob(resolve);
                } else {*/
                  // console.log('ceheck elsee got new2 hereeeee for safariii')
                  const canvas = document.createElement("canvas");
                  canvas.width = width;
                  canvas.height = height;
                  canvas.getContext("2d").drawImage(image, 0, 0, width, height);
                  const dataUrl = canvas.toDataURL();
                  resolve(dataURItoBlob(dataUrl));
                  // const canvas = document.createElement("canvas");
                  // const ctx = canvas.getContext("2d");
                  // ctx.clearRect(0, 0, canvas.width, canvas.height);
                  // ctx.save();
                  // ctx.translate(canvas.width / 2, canvas.height / 2);
                  // ctx.rotate(90 * Math.PI / 180);
                  // ctx.drawImage(image, 0, 0, width, height);//drawImage(image, -width / 2, -width / 2);
                  // ctx.restore();
                  // const dataUrl = canvas.toDataURL("image/jpeg");
                  // resolve(dataURItoBlob(dataUrl));
                //}
              });
            }));
            ok({ blobs, src: URL.createObjectURL(blobs[0]), imageRatio });
          } catch (err) {
            // console.log('error new occured===>>>', err)
          }
        });
      };
  
      image.src = url;
    });
  };